// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
  var msViewportStyle = document.createElement('style')
  msViewportStyle.appendChild(
    document.createTextNode(
      '@-ms-viewport{width:auto!important}'
    )
  )
  document.querySelector('head').appendChild(msViewportStyle)
}

jQuery(document).ready(function () {
  // LazyLoading
  jQuery("img").unveil(500, function () {
    jQuery(this).on('load', function () {
      jQuery(this).removeAttr("data-src");
    });
  });
  /*$.fn.selectpicker.Constructor.BootstrapVersion = '4';
  $(".bs-select").selectpicker({
    noneSelectedText: "Nic nevybráno"
  });*/
  jQuery(".fancybox2").fancybox({
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '850px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery(".fancybox3").fancybox({
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '600px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery(".fancybox--w700").fancybox({
    type : 'iframe',
  	iframe : {
  		css : {
  			width : '700px'
  		}
  	},
    smallBtn : true,
    buttons : [],
    afterShow: function(opts, obj) {
      $('<button data-fancybox-close="" class="fancybox-close--down" title="Zavřít">Zavřít</button>').insertAfter('iframe');
    }
  });
  jQuery('input:text, textarea').focus(function(){
		if(this.value === this.defaultValue){
			this.value = '';
		}
	});
	jQuery('input:text, textarea').blur(function(){
		if (!this.value.length) {
			this.value = this.defaultValue;
		}
	});
  var maxLength = 600;
  $('textarea#message').keyup(function() {
    var length = $(this).val().length;
    var length = maxLength-length;
    $('#chars').text(length);
  });
});
